import Flex from '../data/Flex';
import Size from '../data/Size';
import UIFlex, { copyFlex, IUIFlexProps } from './UIFlex';
import './UITitle.scss';

export interface IUITitleProps extends IUIFlexProps{
    title?:string | JSX.Element;
    subtitle?:string | JSX.Element;
    size?:string;
    /**
     * Default is 20
     */
    fontSize?:string;
    marginBottom?:boolean;
    notBold?:boolean;
}

export default function UITitle($props:IUITitleProps){
    let cn:string = "title "+($props.className || "");

    cn = Size.addFontSize(cn,$props.fontSize,Size.s16);
    if($props.size) cn = Size.addSize(cn,$props.size); 

    if($props.marginBottom) cn+=" marginBottom";
    if($props.notBold) cn+=" notBold";

    const flex = copyFlex({direction:Flex.COLUMN},$props.flex);
    
    return (
        <UIFlex className={cn} flex={flex}>
            <div className="titleValue">
                {$props.title}
            </div>
            {$props.subtitle && (
            <div className="subTitleValue">
                {$props.subtitle}
            </div>

            )}
            {$props.children}
        </UIFlex>
    );
}
